export default {
    data() {
        return {

        }
    },
    components: {

    },
    methods: {
        _getAccessToken() {
            const user = window.localStorage.getItem('user')
            if (!user) return ''
            try {
                return JSON.parse(user).accesstoken || ''
            } catch (e) {
                return ''
            }
        },
        _createPlaceholderId(prefix = 'img') {
            return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2)}`
        },
        _handleHttpNotOk(response) {
            if (response.ok) return Promise.resolve(response)
            return response.text().then(text => {
                console.error('错误响应内容:', text)
                throw new Error(`HTTP error! status: ${response.status}, body: ${text}`)
            })
        },
        // 从响应中提取图片数据的方法
        _extractImageFromResponse(data) {
            try {
                // 根据您提供的JSON格式，路径为: candidates[0].content.parts[0].inlineData
                if (data && data.candidates && data.candidates[0].content.parts[0].inlineData) {
                    const inlineData = data.candidates[0].content.parts[0].inlineData
                    const mimeType = inlineData.mimeType || 'image/png'
                    const base64Data = inlineData.data
                    
                    // 返回完整的data URL格式，便于直接渲染
                    return `data:${mimeType};base64,${base64Data}`
                }
                
                // 处理其他可能的响应格式（有些API可能直接返回base64）
                if (data && data.inlineData) {
                    const mimeType = data.inlineData.mimeType || 'image/png'
                    return `data:${mimeType};base64,${data.inlineData.data}`
                }

                if (data && data.data && data.data[0].b64_json) {
                    return `data:image/png;base64,${data.data[0].b64_json}`
                }
                
                if (data.data) {
                    return `data:image/png;base64,${data.data}`
                }
                
                console.warn('未找到图片数据:', data)
                return ''
            } catch (error) {
                console.error('提取图片数据失败:', error)
                return ''
            }
        },
        _pollDoubaoTask({
            queryUrl,
            headers,
            placeholderId,
            maxTry = 60,
            intervalMs = 5000
        }) {
            let tryCount = 0
            const poll = () => {
                fetch(queryUrl, {
                        method: 'GET',
                        headers
                    })
                    .then(res => res.json())
                    .then(result => {
                        const taskStatus = result && result.status
                        if (taskStatus === 'succeeded') {
                            const videoUrl = result.content && result.content.video_url
                            const idx = this.sessions.findIndex(s => s.id === placeholderId)
                            if (idx !== -1) {
                                this.sessions.splice(idx, 1, {
                                    role: 'assistant',
                                    type: 'video',
                                    content: videoUrl,
                                    status: 'succeeded',
                                    id: placeholderId
                                })
                            }
                            this.saveSessionHistory()
                            this.answerOver = true
                            this.thinking = false
                            this.robotAnimate = false
                            this.think && this.think('thinkout')
                            return
                        }

                        if (taskStatus === 'failed' || taskStatus === 'cancelled') {
                            const idx = this.sessions.findIndex(s => s.id === placeholderId)
                            if (idx !== -1) {
                                this.sessions.splice(idx, 1, {
                                    role: 'assistant',
                                    type: 'video',
                                    content: '',
                                    status: 'failed',
                                    id: placeholderId
                                })
                            }
                            this.answerOver = true
                            this.thinking = false
                            this.robotAnimate = false
                            this.think && this.think('thinkout')
                            this.$message && this.$message.error('视频生成失败，请重试')
                            return
                        }

                        // queued / running / unknown：继续轮询
                        tryCount++
                        if (tryCount < maxTry) {
                            setTimeout(poll, intervalMs)
                        } else {
                            this.answerOver = true
                            this.thinking = false
                            this.robotAnimate = false
                            this.think && this.think('thinkout')
                            this.$message && this.$message.warning('视频生成超时，请稍后查看')
                        }
                    })
                    .catch(err => {
                        console.error('查询任务失败:', err)
                        tryCount++
                        if (tryCount < maxTry) {
                            setTimeout(poll, intervalMs)
                        } else {
                            this.answerOver = true
                            this.thinking = false
                            this.robotAnimate = false
                            this.think && this.think('thinkout')
                        }
                    })
            }
            setTimeout(poll, intervalMs)
        },
        // 联网搜索
        async goOnlineSearch(query) {
            try {
                const searchRes = await fetch('https://user.topeti.com/doubao/search_api/web_search', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'originapi': 'https://user.topeti.com'
                    },
                    body: JSON.stringify({
                        Query: query,
                        SearchType: 'web',
                        Count: 10,
                        Filter: {
                            NeedContent: true,
                            NeedUrl: false,
                            Sites: '',
                            BlockHosts: '',
                            AuthInfoLevel: 0
                        },
                        NeedSummary: true,
                        TimeRange: '',
                        QueryControl: {
                            QueryRewrite: false
                        }
                    })
                })
                if (!searchRes.ok) return ''
                const searchData = await searchRes.json()
                const webResults = (searchData.Result && searchData.Result.WebResults) || []
                if (webResults.length === 0) return ''
                const pageTexts = webResults.map((item, index) =>
                    `[${index + 1}] 标题：${item.Title || ''}\n内容：${item.Content || item.Snippet || ''}`
                ).join('\n')
                return `<div style='display: none;'>\n\n以下是联网搜索结果，请结合以下内容回答用户问题：\n${pageTexts}</div>`
            } catch (e) {
                console.error('联网搜索失败:', e)
                return ''
            }
        },
        // 生成图片（gemini）
        genGeminiImage(prompt, valueModel) {
            const accesstoken = this._getAccessToken()
            const _url = `https://user.topeti.com/nicerouter/models/v1beta/models/${valueModel}:generateContent`
            const obj = {
                contents: [
                    {
                        role: 'user',
                        parts: [
                            {
                                "text": prompt
                              }
                        ]
                    }
                ],
                generationConfig: {
                    responseModalities: ['IMAGE']
                }
            }

            // 先 push 占位项，显示图片加载框
            const placeholderId = this._createPlaceholderId('img')
            this.sessions.push({
                role: 'assistant',
                type: 'image',
                content: '',
                id: placeholderId
            })
            this.queryMessage = ''

            fetch(_url, {
                    method: 'POST',
                    headers: {
                        Accesstoken: accesstoken,
                        Originapi: this.$url,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(obj)
                })
                .then(res => this._handleHttpNotOk(res))
                .then(res => res.json())
                .then(data => {
                    // console.log("data==",data)
                    // 从响应中提取图片数据
                    const imageData = this._extractImageFromResponse(data)
                    const idx = this.sessions.findIndex(s => s.id === placeholderId)
                    if (idx !== -1) {
                        this.sessions.splice(idx, 1, {
                            role: 'assistant',
                            type: 'image',
                            content: [{
                                url: imageData
                            }],
                            id: placeholderId
                        })
                        this.saveSessionHistory()
                    }
                    this.answerOver = true
                    this.thinking = false
                    this.robotAnimate = false
                    this.think && this.think('thinkout')
                })
                .catch(error => {
                    console.error('genGeminiImage error:', error)
                    this.think && this.think('thinkout')
                    this.answerOver = true
                    this.thinking = false
                    this.robotAnimate = false
                })
        },
        // 生成图片（gpt）
        genGptImage(prompt, valueModel) {
            const accesstoken = this._getAccessToken()
            const _url = 'https://user.topeti.com/nicerouter/oaimage/v1/images/generations'
            const obj = {
                "model": valueModel,
                "prompt": prompt,
                "n": 1,
                "size": "auto",
                "quality": "auto",
                "format": "jpeg"
            }

            // 先 push 占位项，显示图片加载框
            const placeholderId = this._createPlaceholderId('img')
            this.sessions.push({
                role: 'assistant',
                type: 'image',
                content: '',
                id: placeholderId
            })
            this.queryMessage = ''

            fetch(_url, {
                    method: 'POST',
                    headers: {
                        Accesstoken: accesstoken,
                        Originapi: this.$url,
                        'Content-Type': 'application/json',
                        'Accept': '*/*',
                        'sec-ch-ua': '"Microsoft Edge";v="149", "Chromium";v="149", "Not)A;Brand";v="24"',
                        'sec-ch-ua-mobile': '?0',
                        'sec-ch-ua-platform': '"Windows"'
                    },
                    body: JSON.stringify(obj),
                    mode: 'cors',  // 添加 CORS 模式
                    credentials: 'omit'  // 添加 credentials 设置
                })
                .then(res => this._handleHttpNotOk(res))
                .then(res => res.json())
                .then(data => {
                    // console.log("data==",data)
                    // 从响应中提取图片数据
                    const imageData = this._extractImageFromResponse(data)
                    const idx = this.sessions.findIndex(s => s.id === placeholderId)
                    if (idx !== -1) {
                        this.sessions.splice(idx, 1, {
                            role: 'assistant',
                            type: 'image',
                            content: [{
                                url: imageData
                            }],
                            id: placeholderId
                        })
                        this.saveSessionHistory()
                    }
                    this.answerOver = true
                    this.thinking = false
                    this.robotAnimate = false
                    this.think && this.think('thinkout')
                })
                .catch(error => {
                    console.error('genGeminiImage error:', error)
                    this.think && this.think('thinkout')
                    this.answerOver = true
                    this.thinking = false
                    this.robotAnimate = false
                })
        },
        // 生成图片（doubao-image）
        genDoubaoImage(prompt, valueDoubaoIS = '2304x1728') {
            const accesstoken = this._getAccessToken()
            const _url = 'https://user.topeti.com/doubao/api/v3/images/generations'
            const obj = {
                model: 'doubao-seedream-5-0-260128',
                prompt,
                sequential_image_generation: 'disabled',
                response_format: 'url',
                size: valueDoubaoIS,
                stream: false,
                watermark: true
            }

            // 先 push 占位项，显示图片加载框
            const placeholderId = this._createPlaceholderId('img')
            this.sessions.push({
                role: 'assistant',
                type: 'image',
                content: '',
                id: placeholderId
            })
            this.queryMessage = ''

            fetch(_url, {
                    method: 'POST',
                    headers: {
                        Accesstoken: accesstoken,
                        Originapi: this.$url,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(obj)
                })
                .then(res => this._handleHttpNotOk(res))
                .then(res => res.json())
                .then(data => {
                    const idx = this.sessions.findIndex(s => s.id === placeholderId)
                    if (idx !== -1) {
                        this.sessions.splice(idx, 1, {
                            role: 'assistant',
                            type: 'image',
                            content: data.data,
                            id: placeholderId
                        })
                        this.saveSessionHistory()
                    }
                    this.answerOver = true
                    this.thinking = false
                    this.robotAnimate = false
                    this.think && this.think('thinkout')
                })
                .catch(error => {
                    console.error('genDoubaoImage error:', error)
                    this.think && this.think('thinkout')
                    this.answerOver = true
                    this.thinking = false
                    this.robotAnimate = false
                })
        },
        // 生成视频（doubao-video，含轮询）
        genDoubaoVideo(prompt, valueDoubaoVR = '4:3', valueDoubaoVD = 5) {
            const accesstoken = this._getAccessToken()
            const _url = 'https://user.topeti.com/doubao/api/v3/contents/generations/tasks'
            console.log(typeof valueDoubaoVD)
            const obj = {
                model: 'doubao-seedance-1-5-pro-251215',
                content: [{
                    type: 'text',
                    text: `${prompt} --resolution 720p --ratio ${valueDoubaoVR} --duration ${valueDoubaoVD} --camerafixed false --watermark false`
                }]
            }

            // 先 push 占位项，显示视频加载框
            const placeholderId = this._createPlaceholderId('video')
            this.sessions.push({
                role: 'assistant',
                type: 'video',
                content: '',
                status: 'loading',
                id: placeholderId
            })
            this.queryMessage = ''

            const headers = {
                Accesstoken: accesstoken,
                Originapi: this.$url,
                'Content-Type': 'application/json'
            }

            fetch(_url, {
                    method: 'POST',
                    headers,
                    body: JSON.stringify(obj)
                })
                .then(res => this._handleHttpNotOk(res))
                .then(res => res.json())
                .then(data => {
                    const taskId = data && (data.id || (data.data && data.data.id))
                    if (!taskId) throw new Error('未获取到任务id')
                    const queryUrl = `https://user.topeti.com/doubao/api/v3/contents/generations/tasks/${taskId}`
                    this._pollDoubaoTask({
                        queryUrl,
                        headers: {
                            Accesstoken: accesstoken,
                            Originapi: this.$url
                        },
                        placeholderId
                    })
                })
                .catch(error => {
                    console.error('genDoubaoVideo error:', error)
                    this.think && this.think('thinkout')
                    this.answerOver = true
                    this.thinking = false
                    this.robotAnimate = false
                })
        },
        // 再次生图
        reGenImage(session, valueDoubaoIS) {
            if (this.thinking) {
                this.$message.warning('正在努力分析中，请勿重复提交')
                return
            }
            // 找到该 session 对应的用户提问
            const idx = this.sessions.findIndex(s => s.id === session.id)
            const userMsg = idx > 0 ? this.sessions[idx - 1].content : ''
            if (!userMsg) {
                this.$message.warning('找不到原始提示词')
                return
            }
            // 追加用户提问到 sessions 末尾，再走统一生图逻辑
            this.sessions.push({
                role: 'user',
                content: userMsg,
                id: Date.now(),
                edit: false
            })
            this.genDoubaoImage(userMsg, valueDoubaoIS)
        },
        // 下载图片
        downloadImage(content) {
            if (!content || !content.length) return
            content.forEach((item, index) => {
                const url = item.url
                if (!url) return
                fetch(url)
                    .then(res => res.blob())
                    .then(blob => {
                        const blobUrl = URL.createObjectURL(blob)
                        const a = document.createElement('a')
                        a.href = blobUrl
                        a.download = 'image_' + Date.now() + '_' + index + '.png'
                        document.body.appendChild(a)
                        a.click()
                        document.body.removeChild(a)
                        URL.revokeObjectURL(blobUrl)
                    })
                    .catch(() => {
                        // 跨域兜底：直接用链接下载
                        const a = document.createElement('a')
                        a.href = url
                        a.download = 'image_' + Date.now() + '_' + index + '.png'
                        document.body.appendChild(a)
                        a.click()
                        document.body.removeChild(a)
                    })
            })
        },
        // 关闭视频弹窗
        closeVideoDialog() {
            this.videoDialogUrl = ''
            this.videoDialogVisible = false
        },
        // 打开视频弹窗
        openVideoDialog(url) {
            this.videoDialogUrl = url
            this.videoDialogVisible = true
        },
        // 下载视频
        downloadVideo(url) {
            if (!url) return
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    const blobUrl = URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = blobUrl
                    a.download = 'video_' + Date.now() + '.mp4'
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                    URL.revokeObjectURL(blobUrl)
                })
                .catch(() => {
                    // 跨域兜底：直接用链接下载
                    const a = document.createElement('a')
                    a.href = url
                    a.download = 'video_' + Date.now() + '.mp4'
                    a.target = '_blank'
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                })
        },
        // 换行符转换html标签
        formatContent(content) {
            if (!content) return '';
            // 将内容分成隐藏div和普通内容
            const parts = content.split(/(<div style='display: none;'>.*?<\/div>)/g);
            return parts.map(part => {
                // 如果是隐藏的div，保持原样
                if (part.includes('<div style=\'display: none;\'>')) {
                    return part;
                }
                // 其他内容正常转换换行和空格
                return part.replace(/\n/g, '<br>').replace(/ /g, '&nbsp;');
            }).join('');
        },
        // 下载 HTML 文件
        downloadHtml(content) {
            try {
                const blob = new Blob([content], {
                    type: 'text/html;charset=utf-8'
                });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `code-${Date.now()}.html`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                this.$message.success('下载成功');
            } catch (e) {
                console.error('下载失败:', e);
                this.$message.error('下载失败');
            }
        },
        // 预览 HTML
        previewHtml(content) {
            try {
                this.htmlPreviewContent = content;
                // 使用 srcdoc 直接渲染，避免部分环境对 blob/data 的 iframe 限制
                this.htmlPreviewVisible = true;
            } catch (e) {
                console.error('预览失败:', e);
                this.$message.error('预览失败');
            }
        },
        // 关闭预览对话框
        closeHtmlPreview() {
            this.htmlPreviewVisible = false;
            this.htmlPreviewContent = '';
        },
        // 在新窗口打开预览，绕过 iframe 限制
        openNewWindowPreview() {
            try {
                const win = window.open('', '_blank');
                if (!win) {
                    this.$message.error('浏览器拦截了弹窗，请允许弹窗或使用下载功能');
                    return;
                }
                win.document.open();
                win.document.write(this.htmlPreviewContent || '');
                win.document.close();
            } catch (e) {
                console.error('新窗口预览失败:', e);
                this.$message.error('新窗口预览失败');
            }
        },
        // 绑定 HTML 代码块的按钮事件
        bindHtmlCodeButtons() {
            const buttons = document.querySelectorAll('.html-code-btn');
            buttons.forEach(btn => {
                // 检查是否已经绑定过事件（通过检查是否有 data-bound 属性）
                if (btn.getAttribute('data-bound') === 'true') {
                    return;
                }
                // 标记为已绑定
                btn.setAttribute('data-bound', 'true');

                // 绑定事件
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const action = btn.getAttribute('data-action');
                    // 从相邻的代码块中提取原始代码文本，而不是从属性里取
                    const wrapper = btn.closest('.html-code-block-wrapper');
                    const codeEl = wrapper ? wrapper.querySelector('pre code') : null;
                    const raw = codeEl ? (codeEl.innerText || codeEl.textContent || '') : '';
                    if (!raw) return;
                    if (action === 'download') {
                        this.downloadHtml(raw);
                    } else if (action === 'preview') {
                        this.previewHtml(raw);
                    } else if (action === 'copy') {
                        if (navigator.clipboard && window.isSecureContext) {
                            navigator.clipboard.writeText(raw).then(() => this.$message.success('复制成功'));
                        } else {
                            const ta = document.createElement('textarea');
                            ta.value = raw;
                            ta.style.position = 'fixed';
                            ta.style.opacity = '0';
                            document.body.appendChild(ta);
                            ta.select();
                            document.execCommand('copy');
                            document.body.removeChild(ta);
                            this.$message.success('复制成功');
                        }
                    }
                });
            });

            // 绑定切换图标事件
            const toggleIcons = document.querySelectorAll('.html-code-toggle-icon');
            toggleIcons.forEach(icon => {
                if (icon.getAttribute('data-bound') === 'true') {
                    return;
                }
                icon.setAttribute('data-bound', 'true');
                icon.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const wrapper = icon.closest('.html-code-block-wrapper');
                    if (!wrapper) return;

                    const codeContainer = wrapper.querySelector('.html-code-container');
                    const loadingEl = wrapper.querySelector('.html-code-loading');
                    const completedEl = wrapper.querySelector('.html-code-completed');

                    if (!codeContainer) return;

                    // 切换显示/隐藏代码
                    const isCodeVisible = codeContainer.style.display !== 'none' && codeContainer.style.display !== '';
                    const isStreaming = wrapper.getAttribute('data-streaming') === 'true';

                    if (isCodeVisible) {
                        // 隐藏代码，显示loading/completed状态
                        codeContainer.style.display = 'none';
                        // 根据流状态显示对应的状态
                        if (isStreaming && loadingEl) {
                            loadingEl.style.display = 'block';
                        } else if (!isStreaming && completedEl) {
                            completedEl.style.display = 'block';
                        }
                        // 切换图标为查看图标
                        // icon.classList.remove('el-icon-hide');
                        // icon.classList.add('el-icon-view');
                    } else {
                        // 显示代码，隐藏loading/completed状态
                        codeContainer.style.display = 'block';
                        if (loadingEl) {
                            loadingEl.style.display = 'none';
                        }
                        if (completedEl) {
                            completedEl.style.display = 'none';
                        }
                        // 切换图标为隐藏图标
                        // icon.classList.remove('el-icon-view');
                        // icon.classList.add('el-icon-hide');
                    }
                });
            });
        },
        // 更新HTML代码块状态（从loading变为completed）
        updateHtmlCodeBlocksStatus() {
            this.$nextTick(() => {
                const wrappers = document.querySelectorAll('.html-code-block-wrapper[data-streaming="true"]');
                wrappers.forEach(wrapper => {
                    const loadingEl = wrapper.querySelector('.html-code-loading');
                    const completedEl = wrapper.querySelector('.html-code-completed');

                    if (loadingEl && completedEl) {
                        // 隐藏loading，显示completed
                        loadingEl.style.display = 'none';
                        completedEl.style.display = 'block';
                        // 更新标记
                        wrapper.setAttribute('data-streaming', 'false');
                        // 重新绑定按钮事件
                        this.bindHtmlCodeButtons();
                    }
                });
                this.renderMermaidCharts();
            });
        },

        // 添加错误处理方法
        handleMermaidError(chartElement, err) {
            chartElement.innerHTML = `<div class="mermaid-error">图表处理异常: ${err.message}</div>`;
        },

        // 添加 Mermaid 复制按钮
        addMermaidCopyButton(container, code) {
            const copyButton = document.createElement('button');
            copyButton.className = 'mermaid-copy-btn';
            copyButton.innerHTML = '<i class="WSiconfont WSicon-fuzhiicon"></i>复制代码';
            copyButton.onclick = () => this.copyMermaidCode(code);

            const actionsDiv = document.createElement('div');
            actionsDiv.className = 'mermaid-actions';
            actionsDiv.appendChild(copyButton);

            container.appendChild(actionsDiv);
        },

        // 复制 Mermaid 代码
        copyMermaidCode(code) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(code).then(() => {
                    this.$message.success('Mermaid 代码复制成功');
                });
            } else {
                const textarea = document.createElement('textarea');
                textarea.value = code;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                this.$message.success('Mermaid 代码复制成功');
            }
        },
    }
}
